export const VIDFLEET_CAMERA_LOGS_REQUEST = "VIDFLEET_CAMERA_LOGS_REQUEST";
export const VIDFLEET_CAMERA_LOGS_RESULT = "VIDFLEET_CAMERA_LOGS_RESULT";